const buildOptimisticIncidentEntryBase = ({
  entry,
  timestamp,
  title,
  content,
  triggerSummary,
  icon,
  color,
  incidentData,
  extra = {},
}) => ({
  id: entry.id || `local-${Date.now()}`,
  childId: entry.childId,
  type: entry.type || 'behavioral',
  timelineType: 'incident',
  collection: 'incidents',
  category: 'incident',
  title,
  content,
  notes: entry.notes || null,
  triggerSummary,
  timestamp,
  icon,
  color,
  tags: entry.tags || [],
  importantMoment: !!entry.importantMoment,
  incidentData,
  ...extra,
});

const buildOptimisticMoodEntryBase = ({
  entry,
  timestamp,
  moodValue,
  notes,
  contextSnapshot,
  incidentData,
  severityLabel,
  triggerSummary,
  remedy,
  extra = {},
}) => ({
  id: entry.id || `local-${Date.now()}`,
  childId: entry.childId,
  type: 'mood',
  timelineType: 'mood',
  collection: entry.collection || 'dailyCare',
  category: 'mood',
  actionType: 'mood',
  title: 'Mood',
  titlePrefix: 'Mood',
  content: String(moodValue),
  moodValue: String(moodValue),
  text: entry.text || entry.content || '',
  notes,
  timestamp,
  updatedAt: entry.updatedAt || timestamp,
  tags: entry.tags || [],
  importantMoment: !!entry.importantMoment,
  contextSnapshot,
  incidentData,
  severity: entry.severity,
  severityLabel,
  triggerSummary,
  remedy,
  ...extra,
});

export { buildOptimisticIncidentEntryBase, buildOptimisticMoodEntryBase };
